module.exports = __webpack_public_path__ + "img/fb-msg.ad80a6b9.png";